import { ActionIcon, Box, Flex, Modal, Stack, Text, TextInput } from '@mantine/core';
import { IconPlus as AddIcon } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Award } from '@/module/Author/Award';
import { AwardCard } from '@/module/Author/Award/components/Card/AwardCard';
import { useFilterAvailable } from '@/module/Laboratory/criteria/components/hooks/useFilterAvailable';

import { NoContentPlaceholder } from '@/core/components';

interface CriteriaAwardSelectAddModalProps {
  available: Award[];
  selected: Award[];

  close: () => void;
  onAdd: (award: Award) => void;
}

export function CriteriaAwardSelectAddModal({ available, selected, close, onAdd }: CriteriaAwardSelectAddModalProps) {
  const { t } = useTranslation();
  const { searchProps, options } = useFilterAvailable({ available, selected });

  return (
    <Modal
      size="70vw"
      opened
      onClose={close}
      withCloseButton={false}
    >
      <Box p="sm">
        <Text
          fw="500"
          size="lg"
        >
          Premii
        </Text>
        <TextInput
          label="caută după titlu și autori"
          {...searchProps}
        />
      </Box>
      <Box
        mah="70vh"
        style={{ overflow: 'scroll' }}
      >
        {options.length === 0 && <NoContentPlaceholder title="Nu exista date" />}
        <Stack p="sm">
          {options.map(award => (
            <Flex
              align="center"
              key={award.id}
            >
              <ActionIcon
                mr="5px"
                onClick={() => onAdd(award)}
                variant="filled"
                aria-label={t('button.add')}
              >
                <AddIcon
                  style={{ width: '70%', height: '70%' }}
                  stroke={1.5}
                />
              </ActionIcon>
              <AwardCard
                award={award}
                onClick={() => window.open(`/author/award/${award.id}`)}
              />
            </Flex>
          ))}
        </Stack>
      </Box>
    </Modal>
  );
}
